import React from 'react';

const FilterButtonLink = ({
  onClickHandler,
  filter,
  name,
  counter,
  isActive,
  useSeparator,
}) => {
  const eventHandler = () => onClickHandler(filter);
  const activeClass = isActive ? 'active' : '';

  return (
    <React.Fragment>
      <button className={`tab-btn ${activeClass}`} onClick={eventHandler}>
        {name}
        {Number.isInteger(counter) && <span> ({counter || 0})</span>}
      </button>
      {useSeparator && <span className="tab-separator">|</span>}
    </React.Fragment>
  );
};

export default FilterButtonLink;
